/**
 * Extracts the Google Drive folder ID from a URL.
 *
 * @param url The Google Drive URL (e.g., https://drive.google.com/drive/folders/FOLDER_ID?...)
 * @returns The folder ID, or undefined if the URL is not a valid Google Drive folder URL.
 */
export function extractGDFolderId(url: string): string | undefined {
    // ?<= ensures it's a google drive url, then takes characters from after /folders until the ?
    const regex = new RegExp("(?<=https://drive.google.com/drive/folders/)[^\\?]*(?!\\?)?");
    const match = regex.exec(url);
    if (match) {
        return match[0];
    } else {
        return undefined;
    }
}
